<template>
  <div class="mt-12">
    <div class="card bg-white rounded-xl p-4 ">
      <div class="relative">
        <div class="card top_primary_card bg-primary font-bold text-white p-4 rounded-xl absolute -top-11 w-full">
          Checklist ({{checklistList.length}})
        </div>
      </div>
      <div class="mt-8">
        <div class="flex flex-wrap justify-between items-center">
          <div class="w-72 mb-4">
          </div>
          <div class="mb-4">
            <Button @buttonAction="addNewChecklist" :btnSize="'large'" :textColor="'white'" :btnColor="'primary'" :btnText="'Add Checklist'"/>
          </div>
        </div>
      </div>
      <div>
        <div style="overflow-y: auto; white-space: nowrap;" class="" v-if="checklistList.length > 0">
          <div v-for="(data, index) in checklistList" :key="index"  class="cust_card m-2  heading-3 border-b border-gray1  bg-white  text-sm px-3 py-3 items-center hover:bg-gray1 cursor-pointer" @click="openDetail(data.checkListItemMasterId, data)">
            <div class="flex items-center justify-between">
              <p class="text-gray4 heading-5" style="font-weight: bold;">{{data.checkListTitle}}
              </p>
            </div>
          </div>
        </div>
        <div v-else>
          <NoRecords :alertMessage="`No records found.`" />
        </div>
      </div>
    </div>
    <add-edit-checklist v-if="addChecklist" :selectedItemId="selectedId" />
   </div>
</template>
<script>
import MyJobApp from '@/api/MyJobApp.js'
import NoRecords from '@/View/components/noRecords.vue'
import Button from '@/View/components/globalButton.vue'
import AddEditChecklist from './list/addEditCheckListItem.vue'

// Static checklist data array
let checklistData = [
  {
    checkListMasterId: 1,
    checkLiTitle: 'Verify customer requirements',
    isActive: true
  },
  {
    checkListMasterId: 2,
    checkLiTitle: 'Check all tools are available',
    isActive: true
  },
  {
    checkListMasterId: 3,
    checkLiTitle: 'Confirm job location and access',
    isActive: true
  },
  {
    checkListMasterId: 4,
    checkLiTitle: 'Review safety protocols',
    isActive: true
  },
  {
    checkListMasterId: 5,
    checkLiTitle: 'Take before photos',
    isActive: true
  }
];

export default {
  components: {
    NoRecords,
    Button,
    AddEditChecklist
  },
  data() {
    return {
      checklistList: [],
      addChecklist: false,
      totalCount: 0,
      selectedId: 0,
      selectedDetail: {},
      searchValue: '',
      filterObject: {
        start: 0,
        length: 20,
        sortOrder: 'DESC',
        isActive: true,
        sortBy: '',
        statusList: []
      },
    };
  },
  created() {},
  mounted() {
    document.body.style = 'overflow: visible;'
    this.getChecklistList()
    this.$root.$on("addNewChecklistComponent", (response, data) => {
      if (response) {
        if (data && data.action === 'add') {
          this.addChecklistToArray(data.checklist);
        } else if (data && data.action === 'update') {
          this.updateChecklistInArray(data.checklist);
        } else if (data && data.action === 'delete') {
          this.deleteChecklistFromArray(data.checkListMasterId);
        }
        this.getChecklistList()
        this.addChecklist = false
      }
      this.addChecklist = false
    });
    this.$root.$on("closeaddEditItems", (response) => {
      if (response) {
        this.getChecklistList()
      }
      this.addChecklist = false
    });
  },
  beforeDestroy() {
    this.$root.$off('addNewChecklistComponent')
    this.$root.$off('closeaddEditItems')
  },
  methods: {
    addChecklistToArray(checklist) {
      const newId = checklistData.length > 0
        ? Math.max(...checklistData.map(item => item.checkListMasterId)) + 1
        : 1;

      checklistData.push({
        ...checklist,
        checkListMasterId: newId
      });
    },
    updateChecklistInArray(checklist) {
      const index = checklistData.findIndex(item => item.checkListMasterId === checklist.checkListMasterId);
      if (index > -1) {
        checklistData[index] = { ...checklist };
      }
    },
    deleteChecklistFromArray(checkListMasterId) {
      const index = checklistData.findIndex(item => item.checkListMasterId === checkListMasterId);
      if (index > -1) {
        checklistData.splice(index, 1);
      }
    },
    openDetail (checkListMasterId, data) {
      this.selectedId = checkListMasterId
      this.selectedDetail = data
      this.addChecklist = true
    },
    addNewChecklist () {
      this.selectedId = 0
      this.selectedDetail = {}
      this.addChecklist = true
    },
    getChecklistList () {
      this.$store.dispatch('SetLoader', {status: true, message: 'Loading...'})
      MyJobApp.GetCheckListItemList(
        this.filterObject.start,
        this.filterObject.length,
        this.searchValue,
        this.filterObject.sortBy,
        this.filterObject.sortOrder,
        this.filterObject.isActive,
        0,
        response => {
          this.$store.dispatch('SetLoader', {status: false, message: 'Loading...'})
          let tempList = response.Data.tableRow !== null ? response.Data.tableRow : []
          this.checklistList = tempList
          this.totalCount = response.Data.count
          this.resetPaginationValues = false
          this.$store.dispatch('SetLoader', { status: false, message: '' })
        },
        () => {
          this.resetPaginationValues = false
          this.$store.dispatch('SetLoader', { status: false, message: '' })
        }
      )
      // Simulate API delay
      // setTimeout(() => {
      //   this.checklistList = [...checklistData];
      //   this.$store.dispatch('SetLoader', {status: false, message: ''})
      // }, 300);
    }
  },
};
</script>
<style scoped>
.lead_name_col {
  min-width: 280px !important;
  width: 280px !important;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  padding-right: 8px;
}
</style> 
